import React, { Component } from "react"
// import PropTypes from 'prop-types';

import Select from "ui/legacy/Select"
import { Dropdown } from "ui"

class SelectAttribute extends Component {
    render() {
        return <Dropdown {...this.props} />
    }
}

SelectAttribute.propTypes = Select.propTypes

export default SelectAttribute



// WEBPACK FOOTER //
// ./src/features/editor/attributes/SelectAttribute.js